import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79584023"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-list-wrap" }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_5 = { class: "video-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]

import { withDefaults, ref, nextTick } from 'vue'
import { ImagePreview, Overlay } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'media-list',
  props: {
    list: { default: () => [] },
    isVideo: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { list: any[], isVideo?: boolean };



const currentVideoUrl = ref('')
const overlayShow = ref(false)
const videoVm = ref()

function imagePreviewHandle(index: number) {
  ImagePreview({
    images: props.list.map((item) => item.url),
    startPosition: index,
  })
}

function videoPlay(url: string) {
  console.log('222', 222)
  currentVideoUrl.value = url
  overlayShow.value = true
  nextTick(() => {
    if (videoVm.value?.play) {
      videoVm.value.play()
    }
  })
}

function overlayCloseHandle() {
  overlayShow.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (__props.list?.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.list, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              (!props.isVideo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: item.thumb_url || item.url,
                    alt: "",
                    onClick: ($event: any) => (imagePreviewHandle(index))
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "video-item",
                    onClick: ($event: any) => (videoPlay(item.url))
                  }, null, 8, _hoisted_3))
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无"))
    ]),
    _createVNode(_unref(Overlay), {
      show: overlayShow.value,
      onClick: overlayCloseHandle,
      class: "van-overlay",
      ref: "overlayRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "close-item",
            onClick: _withModifiers(overlayCloseHandle, ["stop"])
          }, null, 8, _hoisted_6),
          (overlayShow.value)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                "x5-playsinline": "",
                muted: "",
                "webkit-playsinline": "",
                playsinline: "",
                loop: "true",
                controlslist: "nodownload",
                controls: "",
                id: "video-play",
                ref_key: "videoVm",
                ref: videoVm,
                src: currentVideoUrl.value
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})